import script from "./AddPackageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddPackageModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddPackageModal.vue?vue&type=style&index=0&id=38c7f7ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c7f7ac"]])

export default __exports__